import { styled } from "styled-components";

export const PersonalInfoText = styled.span`
  width: 100%;
  color: gray;
  font-weight: 600;
  margin: 8px;
  margin-left: 40px;
`;
